export default function clsx(classes: string[] | string | undefined) {
  return ([] as string[]).concat(classes ?? []).filter((cls) => cls);
}
